	<div>
		<line-chart :style="graphstyles"></line-chart>
		<!-- <scatter></scatter> -->
	</div>

	<script>
	import { Line } from 'vue-chartjs'
// import { Bar, Line } from 'vue-chartjs'
export default{
	extends: Line,
	props:['graph_label','graph_value'],
	data(){
		return{
			// graph_label:[],
			// graph_value:[],
		}
	},
	computed: {
		graphstyles () {
			return {
				height: "120px",
				position: 'relative'
			}
		}
	},
	methods:{
		
		initChart(){
			this.renderChart({
				labels: this.graph_label,
				datasets: [
				{
					fill: false,
					legend: {
						display: false
					},
					borderColor: '#1DC895',
					label: '',
					backgroundColor: '#333232',
					data: this.graph_value,
				}
				],
			},
			{
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				scales: {
					yAxes: [
					{
						id: 'y-axis-1',
						type: 'linear',
						display: true,
						position: 'left',
						ticks: {
							beginAtZero: true,
							stepSize: 10,
							min: 0,
						// max: 100
					}
				}
				]
			}
			// tooltips: {
			// 	callbacks: {
			// 		label: function(tooltipItem) {
			// 			return tooltipItem.yLabel;
			// 		}
			// 	}
			// }
		})
		}


	}
}

</script>